import { List } from "immutable"
import * as React from "react"
import { ActivitySummaryProps } from "../../../Shared/components/LegacyProps"
import { noResultsText } from "../../custom_api/api"
import { ActivitySummary } from "../components/activity_summary"
import { trackActivityClick } from "./library/tracking"

export interface ActivityClusterProps {
  readonly title?: string
  readonly description?: string
  readonly slug: string
  readonly activitySummaries: List<ActivitySummaryProps>
}

export const ActivityCluster: React.StatelessComponent<ActivityClusterProps> = p => (
  <section className="block block--activity-cluster container--lg align--center" data-anchor={p.slug}>
    <header className="block__header container--m align--center">
      {p.title && <h2 className="block__title title--l container--xs">{p.title}</h2>}
      {p.description && <div className="block__intro container--s text--styled"><p>{p.description}</p></div>}
    </header>

    {p.activitySummaries.isEmpty()
      ? (
        <div className="text--styled container--m align--center">
          <p className="weight--bold container--s">{noResultsText}</p>
        </div>
      ) : (
        <ul className="row teasers">

          {p.activitySummaries.map((s, i) => (
            <ActivitySummary
              key={`activity-summary-${i}`}
              headingLevel="h3"
              onClick={() => trackActivityClick(s.title, p.title)}
              {...s}
            />
          ))}
        </ul>
      )
    }
  </section>
)

{/* TH: Added to styleguide! */}
